import type { AfterResponseHook } from 'ky';
import { AUTH_ENDPOINT_KEY, LOGOUT_URL_WITH_PERSIST_PATH } from '../../../../auth/const';
import { redirectOn401 } from '../../../handle401';
import { addTenantPrefix } from '../../../tenantBasePath';
import { isServer } from '../../utils';
import { postLogoutAndRedirect } from '../../utils/logout';
import type { HookGetterArgs } from '../types';

const getPathNameFromUrl = (url: string) => {
  const urlObj = new URL(url);
  return urlObj.pathname;
};

/**
 * upon logout, multiple api calls return 401, but we need to redirect only once. Otherwise, the confirmation popup will be shown multiple times.
 */
let hasRedirectedToLogoutPage = false;

export const handleLogout = ({ options, executeFetch }: HookGetterArgs): AfterResponseHook => {
  const handleLogoutHook: AfterResponseHook = (req, _opts, response) => {
    if (
      redirectOn401 &&
      response.status === 401 &&
      // req path doesn't start with /auth
      !getPathNameFromUrl(req.url).includes(AUTH_ENDPOINT_KEY) &&
      !isServer() &&
      // a 401 from a followed cross-origin redirect is some storage host refusing us, not our
      // session expiring — navigating the whole page to logout on it would be wrong
      !(response.redirected && new URL(response.url).origin !== window.location.origin) &&
      // disable auto redirect for cors domain
      !options.credentials &&
      !hasRedirectedToLogoutPage
    ) {
      // redirect to login page
      hasRedirectedToLogoutPage = true;
      const logoutUrl = addTenantPrefix(LOGOUT_URL_WITH_PERSIST_PATH, options.meta?.basePath);
      void postLogoutAndRedirect({
        logoutUrl,
        fallbackUrl: window.location.href,
        options,
        executeFetch,
      });
    }

    if (response.ok && response.redirected && options.shouldRedirect !== false) {
      // Extract the Location header from the response
      // const redirectUrl = response.headers.get('Location');
      // Manually follow the redirect
      window.location.href = response.url;
    }
  };
  return handleLogoutHook;
};
